import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ id, input }) => {
	const query = gql`
		mutation updateCase($id: String!, $input: updateCaseInput!) {
			updateCase(id: $id, input: $input) {
				status
				errors
				errors_2 {
					code
					message
				}
			}
		}
	`
	const variables = { id, input }
	const res = await api({ query, variables })
	return Promise.resolve(res)
}
